<template>
  <div class="default-modal__header" :class="{ 'default-modal__header--transparent': transparent }">
    <span class="default-modal__title">{{ title }}</span>
    <slot></slot>
    <button type="button" class="default-modal__close" @click="emit('close')">
      <IconComponent name="close" category="other" />
    </button>
  </div>
</template>

<script setup>
/**
 * Imports
 */

/**
 * Props & Emits
 */
defineProps({
  title: {
    type: String,
  },
  transparent: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);
</script>
